export const STORE_WEB3_CONTEXT = "STORE_WEB3_CONTEXT";
export const SET_CHAIN_DATA = "SET_CHAIN_DATA";
export const SHOW_SNACKBAR = "SHOW_SNACKBAR";
export const SET_NETWORK = "SET_NETWORK";
